import * as React from 'react';
import { LoginCallback } from '@okta/okta-react';
import { CircularProgress, Box, Typography } from '@mui/material';

/**
 * Handles the /login/callback route after Okta redirects back with the auth code.
 * Token exchange is done by Okta's <LoginCallback>; on success it calls
 * `restoreOriginalUri` (see OktaProvider) which sends the user back to the page
 * they were trying to reach (or "/" if none).
 */
const Loading: React.FC = () => (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
    >
        <CircularProgress />
        <Typography style={{ marginTop: 16 }}>Signing you in…</Typography>
    </Box>
);

const ErrorView: React.FC<{ error: Error }> = ({ error }) => (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        padding={3}
    >
        <Typography variant="h6" color="error" gutterBottom>
            Sign-in failed
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
            {error?.message ?? 'An unexpected error occurred.'}
        </Typography>
        <Typography variant="body2" style={{ marginTop: 16 }}>
            <a href="/login">Return to login</a>
        </Typography>
    </Box>
);

export const OktaLoginCallback: React.FC = () => (
    <LoginCallback loadingElement={<Loading />} errorComponent={ErrorView} />
);
